import {Box, Typography} from '@mui/material';

export const HighRisk = () => {
  return (
    <Box sx={{textAlign: 'center'}}>
      <Box pb={0.8}>
        <Typography
          variant="caption"
          component="div"
          color="red"
          fontWeight="bold"
          fontSize="16px"
          lineHeight={1.3}
        >
          High Risk
        </Typography>
      </Box>
    </Box>
  );
};
